import Vue from "vue";

const estateAdService = {
  searchEstateAds(params) {
    return Vue.http.get("api/estateAd/search", { params });
  },
  getPropertyGroupAds(propertyGroupId, fromDate, hasGarage) {
    return Vue.http.get(`api/estateAd/propertyGroup/${propertyGroupId}`, { params: { fromDate, hasGarage } });
  },
  getAllHoods() {
    return Vue.http.get("api/hood");
  },
};
const scraperService = {
  startScrapeNewAdsJob(userAgent, cookie) {
    return Vue.http.post("api/scraper/startScrapeNewAdsJob", { userAgent, cookie });
  },
  startScrapeExistingAdsDetailsJob(userAgent, cookie) {
    return Vue.http.post("api/scraper/startScrapeExistingAdsDetailsJob", { userAgent, cookie });
  },
  getStatus() {
    return Vue.http.get("api/scraper/getStatus");
  },
  getRuns(hours = 48) {
    return Vue.http.get("api/scraper/runs", { params: { hours } });
  },
  getRuntimeMarker() {
    return Vue.http.get("api/scraper/runtimeMarker");
  },
};

const publisherBlacklistService = {
  get() {
    return Vue.http.get("api/publisherBlacklist");
  },
  replace(publisherNames) {
    return Vue.http.put("api/publisherBlacklist", { publisherNames });
  },
};

const crawlerSourceService = {
  get() {
    return Vue.http.get("api/crawlerSource");
  },
  replace(settings) {
    return Vue.http.put("api/crawlerSource", settings);
  },
};

export { estateAdService, scraperService, publisherBlacklistService, crawlerSourceService };
